import { ConfirmDialog } from '../../components';

import type { NotAttendingSchoolConfirmDialogProps } from './types';

export default function NotAttendingSchoolConfirmDialog({
  open,
  hasEducationInfo,
  confirmLoading,
  onClose,
  onConfirm,
}: NotAttendingSchoolConfirmDialogProps) {
  return (
    <ConfirmDialog
      open={open}
      title={
        hasEducationInfo
          ? 'Remove education information?'
          : 'Confirm child is not attending school?'
      }
      message={
        hasEducationInfo ? (
          <>
            Selecting "Child is not attending school" will permanently delete all education
            information you've entered.
            <br />
            This action can't be undone.
          </>
        ) : (
          'This marks that the child is not attending school.'
        )
      }
      confirmLabel={hasEducationInfo ? 'Remove all' : 'Confirm'}
      confirmLoading={confirmLoading}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
}
